import { request } from "services/api/util";

class AuditLogsService {
  async getListAuditLogs(param) {
    const config = {
      method: "get",
      url: `admin/auditLog`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
  async getListActionsAudit() {
    const config = {
      method: "get",
      url: `admin/auditLogAction`,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new AuditLogsService();
